<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      :title="'CADASTRO DE PARÂMETROS DE CRIAÇÃO DE CARDS PARA NOVAS CONTAS CAPITAIS'"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="input-group" style="background: none">
          <div class="col-md-4">
            <SelectBoard
              ref="boardComponent"
              @onSelect="loadColumns"
              :onlyActive="true"
              :selectedOption="data.boardId"
            />
          </div>
          <div class="col-md-4">
            <SelectBoardColumn
              v-if="data.boardId"
              ref="boardColumnComponent"
              @onSelect="saveBoardAndColumn"
              :boardId="data.boardId"
              :selectedOption="data.boardColumnId"
              :key="data.boardId"
            />
          </div>
          <div class="col-md-4">
            <SelectOrigem
              v-if="data.boardColumnId"
              ref="originComponent"
              @onSelect="saveOrigin"
              :selectedOption="data.originId"
            />
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import { advancedOnException } from '@/components/tools/Utils'

import ParametroGeracaoCardContaCapitalRepository from '@/shared/http/repositories/configurations/parametroGeracaoCardContaCapital'

import SelectBoard from '@/components/forms/selects/SelectBoard.vue'
import SelectBoardColumn from '@/components/forms/selects/SelectBoardColumn.vue'
import SelectOrigem from '@/components/forms/selects/SelectOrigem.vue'

const data = {
  id: null,
  boardId: null,
  boardColumnId: null,
  originId: null
}

export default {
  name: 'NewCapitalAccountParams',
  mixins: [ActionsForm],
  data () {
    return {
      data: data
    }
  },
  components: {
    SelectBoard,
    SelectBoardColumn,
    SelectOrigem
  },
  methods: {
    onLoad () {
      ParametroGeracaoCardContaCapitalRepository.GetAll()
        .then(response => {
          this.data.boardId = response.data.boardId
          this.data.boardColumnId = response.data.boardColumnId
          this.data.originId = response.data.originId
        })
        .catch((error) => console.error(error))
    },
    onClear () {
      this.data.boardId = null
      this.data.boardColumnId = null
      this.data.originId = null
    },
    onCreate () {
      loading.push()

      if (this.data.boardId && this.data.boardColumnId && this.data.originId) {
        ParametroGeracaoCardContaCapitalRepository.Create(this.data)
          .then((response) => {
            toast.success(this.$lang.Common.Alerts.Success)
          })
          .catch((error) => advancedOnException(error, this.$lang))
      }

      loading.close()
    },
    onUpdate () {
      loading.push()

      if (this.data.boardId && this.data.boardColumnId && this.data.originId) {
        this.data.id = parseInt(this.data.id)

        ParametroGeracaoCardContaCapitalRepository.Create(this.data)
          .then((response) => {
            toast.success(this.$lang.Common.Alerts.Success)
          })
          .catch((error) => advancedOnException(error, this.$lang))
      }

      loading.close()
    },
    loadColumns (boardId) {
      this.data.boardId = boardId
      this.data.boardColumnId = null
      this.data.originId = null
    },
    saveBoardAndColumn (boardAndColumn) {
      this.data.boardId = boardAndColumn[0]
      this.data.boardColumnId = boardAndColumn[1]
    },
    saveOrigin (originId) {
      this.data.originId = originId
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros/newCapitalAccountParams/NewCapitalAccountParams.vue